module.exports = __webpack_public_path__ + "img/Niro_Reset_button.88031018.png";